$( document ).ready(function() {
  if(window.location.href.indexOf("?contact") > -1) {
       $('.custom-overlay').addClass('active');
    }
  $("#open-contact-form").click(function(e){
    e.preventDefault
  $('.custom-overlay').addClass('active');
  });

$(document).mouseup(function(e) 
{
    var container = $(".contact-popup-inner");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
       $('.custom-overlay').removeClass('active');
    }
});
  
  $("#hide-contact-form").click(function(e){
    e.preventDefault
  $('.custom-overlay').removeClass('active');
  });
  $("#product-contact-form-submit").click(function(e){
    e.preventDefault();
    var isFormValid = true;

    $(".required input").each(function(){
        if ($.trim($(this).val()).length == 0){
            $(this).addClass("highlight");
            isFormValid = false;
        }
        else{
            $(this).removeClass("highlight");
        }
    });

    if (!isFormValid) alert("Please fill in all the required fields (indicated by *)");
    else $('#custom-product-form').submit();
  });
});